import React from 'react';
import { IconSpan } from '../../../../../../../components/IconSpan';
import { Icon } from '../../../../../../../components/Icon';
import { SignableDocument } from '../../../../../../../entities/v1/applicant_tracking/SignableDocument';
import { previewSignableDocument } from '../../../../../SignableOffers/SendSignableOfferModal/OfferDocuments';
import { SignableOffer } from '../../../../../../../entities/v1/applicant_tracking/SignableOffer';
import { Button } from 'reactstrap';
import snakecaseKeys from 'snakecase-keys';
import { LoadingSpinnerIcon } from '../../../../../../../components/LoadingSpinnerIcon';

interface PropTypes {
  signableOffer: SignableOffer;
}

interface DocumentProps {
  document: SignableDocument;
  signableOffer: SignableOffer;
}

function Document(props: DocumentProps) {
  const [loadingPreview, setLoadingPreview] = React.useState(false);

  return (
    <div className='d-flex align-items-center justify-content-between pb-2h'>
      <IconSpan
        icon={{ name: 'bi-paperclip', className: 'text-dark-500 fs-5' }}
        spanClassName='text-info fs-5'
        spanText={props.document.fileName}
      />
      <Button
        type='button'
        color='borderless'
        disabled={loadingPreview}
        onClick={() =>
          previewSignableDocument(
            props.signableOffer.applicationId,
            props.document.id,
            snakecaseKeys(props.signableOffer.variables),
            setLoadingPreview,
          )
        }
      >
        {loadingPreview ? (
          <LoadingSpinnerIcon className='text-info' />
        ) : (
          <Icon className='text-info' name='bi-box-arrow-up-right' />
        )}
      </Button>
    </div>
  );
}

export function OfferDocuments(props: PropTypes) {
  return (
    <div>
      <h5>The candidate will receive these documents to sign:</h5>
      <div className='bg-gray p-3 rounded-2 pb-1'>
        {props.signableOffer.offerTemplate.signableDocuments.map((document) => (
          <Document
            document={document}
            key={document.id}
            signableOffer={props.signableOffer}
          />
        ))}
      </div>
    </div>
  );
}
